/**
 * /app/beams — list of saved beam designs.
 * Thin wrapper over the shared DesignsList configured for "beams".
 */

import { Square } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function BeamsIndexPage() {
  return (
    <DesignsList
      module="beams"
      description="Diseño de vigas en flexo-cortante — abre uno guardado o crea uno nuevo."
      icon={<Square size={24} strokeWidth={1.5} />}
    />
  );
}
